import { render, staticRenderFns } from "./answerConfirm.vue?vue&type=template&id=69f140b2&scoped=true&"
import script from "./answerConfirm.vue?vue&type=script&lang=js&"
export * from "./answerConfirm.vue?vue&type=script&lang=js&"
import style0 from "./answerConfirm.vue?vue&type=style&index=0&id=69f140b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f140b2",
  null
  
)

export default component.exports